// @flow
import { httpGet, httpPost } from '~/core/api/helpers/helpers.api';

import url from 'url';

export function getDashboardCustomisation(userid: string): Promise<Response> {
    const getDashboardCustomisationURL = url.format({
        pathname: `/web/user/${userid}/attributes/dashboard-config`
    });

    return httpGet(getDashboardCustomisationURL);
}

export function saveDashboardCustomisation(
    userid: string,
    lastUpdated: number,
    pages: Array<Object>
): Promise<Response> {
    const getDashboardCustomisationURL = url.format({
        pathname: `/web/user/${userid}/attributes/dashboard-config`
    });

    const body = { lastUpdated, pages };

    return httpPost(getDashboardCustomisationURL, body);
}



// WEBPACK FOOTER //
// ./src/core/api/dashboard/index.js